import { changeLang } from "@/app/appSlice"
import { RootState } from "@/app/store"

export default function LangSelector() {
  const dispatch = useAppDispatch()
  const lang = useAppSelector((state: RootState) => state.app.lang)

  return (
    <div className="flex h-7">
      {availableLang
        .map((l, li) => {
          return [
            <button
              className="py-1 px-2 lg:mx-2 mx-1 my-0 shadow-none hover:shadow-none bg-transparent flex items-center"
              onClick={() => dispatch(changeLang(l.code))}
              key={l.code}
            >
              <span
                className={
                  lang === l.code ? "text-primary" : "text-header-text"
                }
              >
                {l.display}
              </span>
            </button>,
            <div key={`${l.code}-sep`} className="w-[1px] bg-neutral-300" />,
          ]
        })
        .flat()
        .slice(0, -1)}
    </div>
  )
}
